import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ScrollAnimation from 'react-animate-on-scroll';

class Blog extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL+'/'
    let imagealt = 'image'
    return (
    	<div className="blog-area pd-top-80 pd-bottom-90 go-top">
		  <div className="container">
		    <div className="row justify-content-center">
		      <div className="col-xl-6 col-lg-7">
		        <div className="section-title text-center">
					<ScrollAnimation animateIn="bounceIn">
						<h6 className="sub-title double-line">Latest Blogs</h6>
						<h2 className="title">Our Impressive Blogs</h2>
					</ScrollAnimation>
		        </div>
		      </div>
		    </div><br/><br/>
		    <div className="row">
		        <div className="row justify-content-center">
		          
					<div className="col-md-2">
					
					</div>



					<div className="col-md-4">
						<ScrollAnimation animateIn="fadeInUp">
						<div className="single-blog-inner">
							<div className="thumb">
								<img src={publicUrl+"assets/img/website/Neet.png"} alt="img" />
								{/* <span className="date clrWhite">28 JANUARY, 2020</span> */}
							</div>
							<div className="details">
								<ul className="blog-meta">
								
								</ul>
								<h5><Link to="/crack-neet-2025">Top Resources to Crack NEET – Complete Preparation Guide</Link></h5>
								<p>Becoming a doctor is not just a career choice, it’s a calling. And NEET is the first giant step in that direction. But with lakhs of aspirants vying for limited medical...</p>
								{/* <Link className="read-more-text" to="/">READ MORE <i className="fa fa-angle-right" /></Link> */}
							</div>
						</div>
						</ScrollAnimation>
					</div>



					<div className="col-md-4">
						<ScrollAnimation animateIn="fadeInUp">
						<div className="single-blog-inner">
							<div className="thumb">
								<img src={publicUrl+"assets/img/website/neet-jpg.jpg"} alt="img" />
								{/* <span className="date clrWhite">28 JANUARY, 2020</span> */}
							</div>
							<div className="details">
								<ul className="blog-meta">
								
								</ul>
								<h5><Link to="/clear-neet-first-attempt-roadmap-2025"> Clear NEET in First Attempt – Complete Guide 2025</Link></h5>
								<p> Crack NEET 2025 on your first try with this proven roadmap, daily routine tips, expert coaching advice, and smart study strategies.</p>
								{/* <Link className="read-more-text" to="/">READ MORE <i className="fa fa-angle-right" /></Link> */}
							</div>
						</div>
						</ScrollAnimation>
					</div>


					<div className="col-md-2">
						
					</div>
		      </div>
		    </div>
		  </div>
		</div>

    )
  }
}

export default Blog;
